import { PARAGRAPH, SUBTITLE, TITLE, Title } from '../components';
import { VariablesSection } from '../components/VariablesSection';

const SecondPage = () => {
  return (
    <div>
      <Title
        Title={TITLE.CAMPAIGN_VARIABLES}
        Subtitle={SUBTITLE.STEP_TWO}
        Paragraph={PARAGRAPH.PARAGRAPH_TWO}
      />
      <VariablesSection />
    </div>
  );
};

export default SecondPage;
